import { Panel_Header_default } from "./chunk-7UDHOJ54.js";
import { Panel_default } from "./chunk-QINIPE33.js";

// src/elements/Panel/index.ts
var PanelComponent = Panel_default;
PanelComponent.Header = Panel_Header_default;
PanelComponent.Header.displayName = "Panel.Header";
export { PanelComponent };